import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nexus-information-maps',
  templateUrl: './information-maps.component.html',
  styleUrls: ['./information-maps.component.css']
})
export class InformationMapsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
